<template>
  <v-dialog
      overlay-color="grey"
      overlay-opacity="0.5"
      :value="dialog"
      @input="dialog = $event"
      max-width="1500"
      scrollable
      style="margin: 14px"
  >
    <v-card :color=" this.$vuetify.theme.dark ? '#121212' : '#fff'"
            height="100%" width="95%">
      <v-row class="gy-1">
        <v-col cols="12" :md="calledPageType.includes('Assign') ? 5 : 12">

          <v-row>
            <card-class
                :selected-assign="selectedAssign"
                :user="selectedAssign.student"
                :called-page-type="calledPageType"
            >
              <template v-slot:title>
                <v-row >
                  <v-col cols="5" v-if="selectedAssign.registerId"> <span style="font-size: 12px;">Register : {{ selectedAssign.registerId }} - {{ selectedAssign.registerStatus }}</span></v-col>
                  <v-col cols="7" v-if="selectedAssign.assignId">   <span style="font-size: 12px;">Assign : {{ selectedAssign.assignId }} - {{ selectedAssign.assignStatus }}      </span></v-col>
                </v-row>
              </template>
              <template v-slot:action>
              </template>
            </card-class>

            <v-card-subtitle> Teacher : {{ selectedAssign.teacherName }}</v-card-subtitle>
            <v-row>
              <v-col cols="6">
                <v-textarea dense label="Test Feedback" rows="3" counter v-model="selectedAssign.feedback"  ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea dense label="Registered Comment" rows="3" counter :readonly=!isManager v-model="selectedAssign.registerMention" ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="calledPageType.includes('Register')">
              <v-col cols="4" sm="3"><v-btn v-if="isOwner" color="red darken-4"  dark rounded small label="Create Class" @click="createAssign()">수업 생성</v-btn></v-col>
              <v-col cols="4" sm="3"><v-btn color="yellow darken-1"  dark rounded small label="Test Complete" @click="completeTest()">Test Complete</v-btn></v-col>

            </v-row>
          </v-row>
        </v-col>
        <v-col cols="12" md="7"
               v-if="calledPageType.includes('Assign')" >
<!--                <v-content :height="isManager || isOwner ? '40vh' : '25vh'">-->
          <v-row>
            <v-sheet>
              <v-card-title>Assign </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col><v-text-field dense label="Assign Count"   :readonly=!isManager v-model="selectedAssign.assignCount"></v-text-field></v-col>
                  <v-col><v-text-field dense label="Attended Count" :readonly=!isManager v-model="countAttended"></v-text-field></v-col>
                  <v-col><v-text-field dense label="Postpone Count" :readonly=!isManager v-model="countPostponed"></v-text-field></v-col>
  <!--                <v-col><v-text-field dense label="Left Count" :readonly=!isManager v-model="leftCount"></v-text-field></v-col>-->
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-textarea dense label="Assign Comment" rows="3" counter :readonly=!isManager v-model="selectedAssign.assignMention" ></v-textarea>
              </v-card-text>
              <v-card-actions v-if="isManager || isOwner">
                <v-row >
                  <v-col cols="4" sm="4" v-if="isManager"  class="gy-0"><v-btn block small color="yellow darken-4"      dark   @click="sendZoomAcceptRequest()">Zoom Request</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isManager"  class="gy-0"><v-btn block small color="red darken-4"         dark   @click="noticeTeacherChanged()">Teacher Changed</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isManager"  class="gy-0"><v-btn block small color="grey"                 dark   @click="completeAssignClass()">Class Complete</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isManager"  class="gy-0"><v-btn block small color="orange darken-2"      dark   @click="requestChangeTeacher()">Request Change Teacher</v-btn></v-col>

                  <v-col cols="4" sm="4" v-if="isManager"  class="gy-0"><v-btn block small color="blue darken-4"         dark   @click="linkReceipt()">영수증</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isOwner"  class="gy-0">  <v-btn block small color="green darken-4"       dark   @click="sendAssignmentSheet()">수강증</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isOwner"  class="gy-0">  <v-btn block small color="secondary darken-2"   dark   @click="sendAttendanceSheet(false)">출석증</v-btn></v-col>
                  <v-col cols="4" sm="4" v-if="isOwner"  class="gy-0">  <v-btn block small color="secondary darken-2"   dark   @click="sendAttendanceSheet(true)">출석증(개근)</v-btn></v-col>

                  <v-col cols="4" sm="4" v-if="isOwner" class="gy-0">   <v-btn block small color="blue darken-4" dark @click="sendContactRequest()">연락 요청</v-btn></v-col>

                  <v-col cols="3" sm="3" v-if="isOwner"  class="gy-0">
                    <v-text-field dense label="Refund Amount" v-model="refundAmount" />
                  </v-col>
                  <v-col cols="3" sm="3" v-if="isOwner"  class="gy-0">
                    <v-btn block small color="red darken-4"         dark label="Class Stop" @click="quitAssignClass()">수업 중단</v-btn>
                  </v-col>
                  <v-col cols="6" sm="6" v-if="isOwner"  class="gy-0">
                    <v-btn block small color="yellow darken-4"         dark label="Request Review" @click="sendReviewRequest()">리뷰 요청</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-card-text>
                <v-sheet v-if="calledPageType.includes('Assign')">
                  <GridAttend class="agGrid"
                              :attendList="attendList"

                              :column-defines="attendColumnDefs"
                              :is-show-button="true"
                              :is-dialog="true"

                              @onGridReady="onGridReadyAttend"
                              @updateAttend="updateAttend"
                  />
                </v-sheet>
              </v-card-text>
<!--                </v-content>-->
            </v-sheet>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row class="justify-end">
            <v-col cols="4" sm="3" >
              <v-btn color="orange darken-4" dark rounded small @click="updateData">Save(저장)</v-btn>
            </v-col>
            <v-col cols="4" sm="3" >
              <v-btn color="blue darken-4" dark rounded small @click="$emit('hide')">Close(닫기)</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import GridAttend from "@/components/Grid/grid-attend";
import apiPayment from "@/api/modules/api-payment";
import apiManager from "@/api/modules/api-manager";
import apiPdf from "@/api/modules/api-pdf";
import apiOwner from "@/api/modules/api-owner";
import apiRegister from "@/api/modules/api-register";
import CardClass from "@/components/Card/CardClass";
import apiAttend from "@/api/modules/api-attend";
import apiAssign from "@/api/modules/api-assign";

export default {
  name: 'DialogAssign',
  components: { CardClass, GridAttend },
  props: {
    value: {type: Boolean, required: true},
    selectedAssign: {type: Object },
    calledPageType: {type: String, default: ''},
    attendColumnDefs: {type: Array}
  },
  data(){
    return {
      datePickerMenu: false,
      timePickerMenu: false,
      attendList: [],
      listLoading: true,
      searchQuery: {
        originAuth: 'EN9DOOR_STUDENT',
        page: 0,
        size: 5,
        assignStatus: null,
        sort: 'createdAt,desc',
        direction: 'DESC'
      },

      gridApi: {},
      gridOptions: {},
      gridColumnApi: {}
    }
  },
  destroyed() { },
  watch:{
    coumputedData(){
      this.countAttended = this.attendList.filter(attend => ['ATTEND','NOSHOW'].includes(attend.attendStatus)).length
    }
  },
  computed: {
    ...mapGetters(['app','contentState','user','isOwner','isManager','teacherList']),
    dialog: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
    isAssign: function (){
      return this.calledPageType.includes('Assign')
    },
    isRegister: function (){
      return this.calledPageType.includes('Register')
    },
    countAttended: function (){
      if ( this.attendList.length === 0) return 0
      return this.attendList.filter(attend => ['ATTEND','NOSHOW'].includes(attend.attendStatus)).length
    },
    countPostponed: function (){
      if ( this.attendList.length === 0) return 0
      return this.attendList.filter(attend => ['POSTPONE'].includes(attend.attendStatus)).length
    },
    refundAmount: function () {
      if ( this.attendList.length === 0) return this.selectedAssign.price
      let cntAttended = this.attendList.filter(attend => ['ATTEND','NOSHOW'].includes(attend.attendStatus)).length
      let cntPostponed = this.attendList.filter(attend => ['POSTPONE'].includes(attend.attendStatus)).length
      let cntAssigned = this.selectedAssign.assignCount
      if (cntPostponed > 5) cntAttended += cntPostponed -5

      if (cntAttended === 0) {
        return this.selectedAssign.price
      } else if (cntAttended / cntAssigned < 1/3) {
        return Math.ceil(this.selectedAssign.price * 2/3/ 1000) * 1000
      } else if (cntAttended / cntAssigned < 1/2) {
        return Math.ceil(this.selectedAssign.price * 1/2/ 1000) * 1000
      } else
        return 0
    }
  },
  created() { },
  beforeMount() {},
  mounted() {
    this.getAssignInfo()
    this.getAttendList()
  },
  methods: {
    ...mapActions(['fetchClassStartTime']),
    async getAssignInfo() {
      if (!this.selectedAssign.assignId) return

      this.searchQuery.studentId = this.selectedAssign.studentId
      // let register = apiRegister.getRegisterById(selectedAssign.registerId)
      let assign = await apiAssign.getAssign(this.selectedAssign.assignId)
          .then(res => {
            this.selectedRow = res
            this.selectedRow.attendList = res.attendList.sort((a,b) => Date.parse(b.attendDate) - Date.parse(a.attendDate))
            this.isShowAssign = true
            return res
          })
          .catch(err => console.log(err))
      let register = await apiRegister.getRegisterByQuery(this.searchQuery)
          .then(res => {
            this.selectedRow.registerId = res.registerId
            this.selectedRow.skypeId = res.skypeId
            this.selectedRow.callAppType = res.callAppType
            this.selectedRow.feedback = res.feedback
            this.selectedRow.registeMention = res.registeMention
            return res
          })
          .catch(err => console.log(err))
      this.searchQuery.studentId = ''
    },
    getAttendList(){
      if (!this.selectedAssign.assignId) return

      let yesterdayDate = new Date().setDate(new Date().getDate() - 1)
      this.searchQuery.assignId = this.selectedAssign.assignId

      apiAttend.getAttendByAssign(this.searchQuery)
          .then(res => {
            return res.filter(attend => {
              if ((new Date(attend.attendDate) >= new Date(yesterdayDate).setHours(0) ||
                  attend.attendStatus != 'NOCLASS') && this.isStudent){
                return attend
              } else {
                return attend
              }
            })
          })
          .then(attendList => {
            let  minusDays = this.isManager ? 50 : 20
            return this.$addScheduledDates(this.selectedAssign, attendList, minusDays)
          })
          .then(res => res.sort((a, b) => (new Date(b.attendDate) - new Date(a.attendDate))))
          .then(res => this.attendList = res)
          .then(() => this.listLoading = false)
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))

    },
    updateData(){
      this.selectedAssign.content = this.contentState.content.filter(c => c.contentId === this.selectedAssign.contentId)[0]
      this.$emit('updateData', this.selectedAssign)
    },



    createAssign(){
      apiOwner.createAssign(this.selectedAssign)
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
    },
    quitAssignClass(){
      this.selectedAssign.refundAmount = this.refundAmount
      apiOwner.quitAssignClass(this.selectedAssign)
          .then(() => {
            this.$dialog.notify.success('Update Successfully', {position: 'top-right', timeout: 1000})
            this.$emit('quitAssignClass', this.selectedAssign)
          })
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    sendContactRequest() {
      apiOwner.sendContactRequest(this.selectedAssign)
          .then(() => this.$dialog.notify.success('Sent Request', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    sendReviewRequest(){
      apiOwner.sendReviewRequest(this.selectedAssign)
          .then(() => this.$dialog.notify.success('Sent Request', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    requestChangeTeacher() {
      apiOwner.requestChangeTeacher(this.selectedAssign)
          .then(() => this.$dialog.notify.success('Sent Request', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },


    completeTest(){
      apiManager.putRegisterCompleteTest(this.selectedAssign)
          .then(res =>{
            this.selectedAssign.registerStatus = "ACTIVE"
            this.$emit('hide')
            return res
          })
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
    },
    linkReceipt(){
      apiPayment.receiptUrl(this.selectedAssign.orderId)
          .then(receiptLink => this.$openWindow(receiptLink, 'book'))
    },
    sendAttendanceSheet(isFake){
      apiPdf.getAttendSheetPopup(this.selectedAssign.assignId, isFake)
          .then(() => this.$dialog.notify.success('출석확인증 이메일로 발송되었습니다.', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    completeAssignClass(){
      apiManager.completeAssign(this.selectedAssign)
          .then(() => this.$dialog.notify.success('Update Successfully', {position: 'top-right', timeout: 1000}))
          .then(() => this.$emit('hide'))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    sendAssignmentSheet(){
      apiPdf.getAssignSheetPopup(this.selectedAssign.assignId)
          .then(() => this.$dialog.notify.success('수강증 이메일로 발송되었습니다.', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    sendZoomAcceptRequest(){
      apiRegister.requestZoomAccept(this.selectedAssign)
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
    noticeTeacherChanged(){
      apiManager.noticeTeacherChanged(this.selectedAssign)
          .then(() => this.$dialog.notify.success('Message Sent', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },


    onGridReadyAttend(params, gridOptions){
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridOptions = gridOptions

      this.gridOptions.api.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))
    },
    // onFirstDataRenderedAttend(params){},
    // onRowDataUpdatedAttend(event){ },
    updateAttend(){}
  },

}
</script>


<style lang="scss">
@import "@/assets/scss/DialogAssign.scss";
</style>